// Shared time display helpers used across call window scheduling flows.
export const formatTimeForDisplay = (timeString: string): string => {
  const [hours, minutes = '00'] = timeString.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'pm' : 'am';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}${minutes === '00' ? '' : `:${minutes}`}${ampm}`;
};

export const formatTimeWindowLabel = (startTime: string, endTime: string): string =>
  `${formatTimeForDisplay(startTime)}–${formatTimeForDisplay(endTime)}`;
